import React from "react";
import CustomModal from "../modal";

const staticStatusCodes = [
  {
    id: 1,
    code: "U",
    name: "Order Placed with Urgent (U)",
    color_code: "#FF6969",
  },
  {
    id: 2,
    code: "P",
    name: "Order Placed with Packing (P)",
    color_code: "#FF6969",
  },
  { id: 3, code: "O", name: "Order Placed with O", color_code: "#FF6969" },
  {
    id: 4,
    code: "Z",
    name: "Order with Placed with Partially Ready (Z)",
    color_code: "#FF6969",
  },
];

const StatusModal = ({ show, onClose, productStatusCode }) => {
  const iconStyle = (color, label, iconName) => {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "12px",
          padding: "3px 0px",
          backgroundColor: "#fff",
          borderRadius: "4px",
          borderBottom: "1px solid #e9ecef",
        }}
      >
        <div
          style={{
            backgroundColor: color,
            width: "24px",
            height: "24px",
            borderRadius: "50%",
            flexShrink: 0,
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: "bold",
            marginRight: "12px",
            fontSize: "12px",
          }}
        >
          {iconName && iconName}
        </div>
        <div
          style={{
            fontSize: "13px",
            color: "#212529",
          }}
        >
          {label}
        </div>
      </div>
    );
  };

  return (
    <CustomModal show={show} onClose={onClose} title="Status Information">
      <div style={{ padding: "8px" }}>
        <div className="status-list">
          {staticStatusCodes?.map((status) => {
            const color = status.color_code || "#000";
            return iconStyle(color, status.name, status.code);
          })}

          {productStatusCode?.map((status) => {
            const color = status.color_code || "#000";
            return iconStyle(color, status.name);
          })}
        </div>

        <div
          style={{
            marginTop: "24px",
            padding: "12px",
            backgroundColor: "#f8f9fa",
            borderRadius: "6px",
            fontSize: "13px",
            border: "1px solid #e9ecef",
          }}
        >
          <div
            style={{
              display: "flex",
              marginBottom: "6px",
              color: "#495057",
            }}
          >
            <span style={{ fontWeight: "500", minWidth: "100px" }}>
              Quantity Format:
            </span>
            <span>Order Qty / Food Ready Qty / Delivered Qty</span>
          </div>
          <div
            style={{
              display: "flex",
              color: "#6c757d",
            }}
          >
            <span style={{ fontWeight: "500" }}>Example:</span>
            <span>
              32/23/20 means 32 Order Qty, 23 Food Ready Qty, 20 Delivered Qty
            </span>
          </div>
        </div>
      </div>
    </CustomModal>
  );
};

export default StatusModal;
